import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const root: SxStyles = {
  border: '1px solid',
  borderColor: NeutralColors.light_neutrals_300,
  borderRadius: '12px',
  backgroundColor: NeutralColors.light_neutrals_0,
};

export const rootLayout: SxStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '40px',
};

export const rootLeft: SxStyles = {
  flexGrow: 1,
  padding: '20px',
  paddingRight: 0,
};

export const rootRight: SxStyles = {
  alignSelf: 'center',
  paddingRight: '20px',
};

export const image = (imageSrc: string): SxStyles => ({
  minWidth: '82px',
  minHeight: '82px',
  width: '82px',
  height: '82px',

  backgroundImage: `url(${imageSrc})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: '100%',
});
